import TimeCount from '@common/TimeCount'
import {
  SHOP_PRODUCTS_PATH,
  TASK_CENTER_PATH,
  TASK_PATH_MAPPING
} from '@constant'
import { getCookie, setCookie } from '@hlj/hlj-utils'
import { getSessionMerchantInfo } from '@merchant-backend/util'
import { getMerchantInfo, goToPubMeal, HLJ_STATISTIC } from '@util'
import { Modal } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import Store from './store'
import style from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getTaskSchedule()
  }

  getAction = () => {
    hashHistory.push(TASK_CENTER_PATH)
  }

  nevigateToProduct = () => {
    hashHistory.push(SHOP_PRODUCTS_PATH)
    HLJ_STATISTIC({
      page_name: '新手任务页',
      event_type: 'element_hit',
      element_tag: 'new_task_receive',
      data_id: getMerchantInfo().id,
      data_type: 'Merchant'
    })
  }

  nevigateToPublishTask = id => () => {
    const path = TASK_PATH_MAPPING[id]
    if (id === 2) {
      goToPubMeal()
    } else {
      path && window.location.replace(path)
    }
  }

  toTaskCenter = () => {
    hashHistory.push(TASK_CENTER_PATH)
  }

  /**
   * 关闭任务未完成提醒框
   */
  closeUnfinishCard = () => {
    const merchantId = getSessionMerchantInfo().user_id || ''
    setCookie(`newShopTaskClosed${merchantId}`, 1, 1)
    this.forceUpdate()
  }

  render() {
    if (!this.store.showTaskSchedule) {
      return null
    }

    const {
      previewModalVisible,
      togglePreviewModal,
      taskSchedule: { merchantTaskDetail, status, endAt }
    } = this.store
    const { undoneCount } = merchantTaskDetail || {}

    switch (status) {
      case 0:
        // 任务未发放，显示弹窗，并调用领取任务接口
        // 弹窗
        return (
          <div>
            <div className={style.taskWapper0} onClick={this.getAction} />
            <Modal
              visible={previewModalVisible}
              wrapClassName={style.modal}
              closable={false}
              footer={null}
            >
              <img
                onClick={() => {
                  togglePreviewModal(false)()
                  this.toTaskCenter()
                  HLJ_STATISTIC({
                    page_name: '首婚礼纪商家后台页',
                    event_type: 'element_hit',
                    element_tag: 'new_growth_plan_hit',
                    data_id: getMerchantInfo().id,
                    data_type: 'Merchant'
                  })
                }}
                src={'//qnm.hunliji.com/FnohTHGxcoXez4oO4J72sZ3fM7cm'}
                style={{ cursor: 'pointer' }}
                width="300"
              />
            </Modal>
          </div>
        )

      case 1:
        // 任务进行中
        return (
          <div className={style.taskWapper1}>
            <div className={style.top}>
              <img
                src="//qnm.hunliji.com/Fk6KsqKPtbgVncECwlOo76pxA68j"
                alt=""
              />
              <p>新店福利：限时完成任务抢专属福利</p>
            </div>
            <div
              className={style.center}
              style={{ marginTop: endAt ? '' : 23 }}
            >
              <span className={style.centertext}>还差</span>
              <span className={style.action}>{undoneCount}</span>
              <span className={style.centertext}>步即可获得流量扶持</span>
            </div>
            <img
              className={style.go}
              src="//qnm.hunliji.com/FhNAbYW67-Ld2ZQgF91kWQGrPFuP"
              onClick={this.toTaskCenter}
            />
            {endAt && (
              <TimeCount endTime={endAt} onEnd={window.location.reload}>
                {(days, hours, minutes, seconds) => {
                  return (
                    <div className={style.timeCount}>
                      <div className={style.countNumber}>{days}</div>
                      <div className={style.dayUnit}>天</div>
                      <div className={style.countNumber}>{hours}</div>:
                      <div className={style.countNumber}>{minutes}</div>:
                      <div className={style.countNumber}>{seconds}</div>
                    </div>
                  )
                }}
              </TimeCount>
            )}
          </div>
        )

      case 2:
        // 任务已完成
        return <div className={style.taskWapper2} onClick={this.getAction} />
      // 扶持期间
      case 3:
      case 4:
        // 扶持已结束
        return (
          <div className={style.taskWapper3}>
            <div className={style.daytop}>
              <div className={style.timeAndTxt}>
                <img
                  className={style.time}
                  src="//qnm.hunliji.com/o_1ddabv4dfg311n2evsg1do41m7217.png"
                />
                {status == 3 ? (
                  <>
                    <span className={style.txt}>新店扶持中</span>
                  </>
                ) : (
                  <span className={style.txt}>新店扶持已结束</span>
                )}
              </div>
              <div
                className={style.allTask}
                onClick={() => {
                  this.getAction()
                  HLJ_STATISTIC({
                    page_name: '新手任务页',
                    event_type: 'element_hit',
                    element_tag: 'new_task_detail',
                    data_id: getMerchantInfo().id,
                    data_type: 'Merchant'
                  })
                }}
              >
                <span>查看详情</span>
              </div>
            </div>
            <div className={style.task3Desc}>
              <div className={style.top}>迅速提升获客能力</div>
              <div className={style.bottom}>线上店铺运营一体化解决方案</div>
            </div>
            <img
              className={style.go}
              src="//qnm.hunliji.com/Ftn9aRUkW3P4gUuNmEvO-Cbk_-A3"
              onClick={this.nevigateToProduct}
            />
          </div>
        )

      case 5:
        const merchantId = getSessionMerchantInfo().user_id || ''
        const closed = getCookie(`newShopTaskClosed${merchantId}`) // 是否已经手动关闭
        // 任务未完成
        return (
          !closed && (
            <div className={style.taskWapper5}>
              <img
                className={style.close}
                src="//qnm.hunliji.com/FjeqvocNXaP1dcXEtglOThreFfYY"
                alt="关闭"
                onClick={this.closeUnfinishCard}
              />
            </div>
          )
        )

      default:
        return null
    }
  }
}
